module.exports = __webpack_public_path__ + "img/meal-input-en.f29ea083.png";